import { Controller } from '@hotwired/stimulus'

class ApplicationController extends Controller {
  connect () {
  }
}

export default ApplicationController
